import { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetPaymentMethods = IAction<EPaymentActions.SET_PAY_METHODS, IMethodData[]>

const setPaymentMethods = (methods: IMethodData[]): TSetPaymentMethods => ({
    type: EPaymentActions.SET_PAY_METHODS,
    payload: methods,
});

export default setPaymentMethods;
